<section class="grid grid-cols-2 gap-4">
  @let formattedPatientInvoiceablesToDate = patientInvoiceablesToDate() | percent: '1.0-2';
  @let defaultToDate = '0%';

  <aux-card
    topText="Patient Invoiceables % to Date"
    [middleText]="formattedPatientInvoiceablesToDate || defaultToDate"
  />

  <aux-card class="col-span-2" [bottomTemplate]="dynamicForecastSettings" />
  <ng-template #dynamicForecastSettings>
    <section class="flex flex-col gap-4 p-2">
      <h2 class="text-lg font-bold">Forecast Assumptions</h2>
      <aux-patient-invoiceables-buffer-input />
    </section>
  </ng-template>

  <aux-reforecast-steps class="col-span-2" />
</section>
